export default __webpack_public_path__ + "static/media/02_photo.0fa2b224.jpg";